import _ from 'underscore';

import Base, { baseInit } from './base';
import { isBlank } from '../helpers/common';

export class Account extends Base {
  id = null; // Integer
  name = null; // String
  abbreviation = null; // String
  prefix = null; // String
  flags = null; // [String]
  active = true;
  organizationId = null; //Integer
  parentId=null; // Integer
  _flags = {}; // Lookup map of flags

  constructor(data) {
    super(data);
    baseInit(this, data, true);

    if (!isBlank(this.flags)) {
      this.flags
        .map((s) => s.trim().toLowerCase())
        .forEach((s) => {
          this._flags[s] = 1;
        });
    }
  }

  hasFlag(needle) {
    return _.has(this._flags, needle.toLowerCase());
  }
}
